import { useEffect } from "react";

interface ForceLightModeProps {
    children: React.ReactNode;
}

/**
 * Forces light mode on the wrapped page.
 * Used for marketing/website pages that don't support dark mode well.
 */
export function ForceLightMode({ children }: ForceLightModeProps) {
    useEffect(() => {
        const root = document.documentElement;

        // Store current theme class to restore later
        const wasDark = root.classList.contains("dark");

        // Force light mode
        root.classList.remove("dark");
        root.classList.add("light");

        return () => {
            // Restore dark mode if it was active when navigating away
            if (wasDark) {
                root.classList.remove("light");
                root.classList.add("dark");
            }
        };
    }, []);

    return <>{children}</>;
}
